<div *ngIf='componentReady' class='ManageSubscriptionDialog'>
  <ng-container *ngIf='hasSubscription; else noSubsciprtion'>
    <div [formGroup]='inputForm' class='ManageSubscriptionDialog__form'>
      <div *ngIf='isLegacyStripe' class='alert alert-warning mb-3'>
        {{ legacyStripeWarning }}
      </div>
      <div class='row'>
        <div class='col col-12 col-md-6 align-content-center'>
          <mat-label>Plan</mat-label>
        </div>
        <div class='col col-12 col-md-6'>
          <app-select [disabled]='isLegacyStripe' [items]='planItems' formControlName='plan_id'
                      label='Selected plan...'></app-select>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12'>
          <mat-accordion>
            <mat-expansion-panel [expanded]='false'>
              <mat-expansion-panel-header>
                <mat-panel-title>Current Plan Details</mat-panel-title>
              </mat-expansion-panel-header>
              <div class='ManageSubscriptionDialog__form__plan-details'>
                <ng-container *ngIf='subscription.paid_by_manager; else selfPaidPlanDetails'>
                  <div class='row'>
                    <div class='col col-12 col-md-6'>
                      <mat-label>Description</mat-label>
                    </div>
                    <div class='col-12 col-md-6'>
                      <b>{{ subscription.additional_user_plan }}</b>
                    </div>
                  </div>
                  <div class='row mt-3'>
                    <div class='col col-12 col-md-6'>
                      <mat-label>Amount</mat-label>
                    </div>
                    <div class='col-12 col-md-6'>
                      <b>${{ subscription.additional_user_cost }}</b>
                    </div>
                  </div>
                  <div class='row mt-3'>
                    <div class='col col-12 col-md-6'>
                      <mat-label>Interval</mat-label>
                    </div>
                    <div class='col col-12 col-md-6'>
                      <b>{{ subscription.payment_interval }}</b>
                    </div>
                  </div>
                  <div class='row mt-3'>
                    <div class='col col-12 col-md-6'>
                      <mat-label>Period</mat-label>
                    </div>
                    <div class='col-12 col-md-6'>
                      <b>{{ subscription.payment_period }}</b>
                    </div>
                  </div>
                </ng-container>
                <ng-template #selfPaidPlanDetails>
                  <div class='row'>
                    <div class='col col-12 col-md-6'>
                      <mat-label>Amount</mat-label>
                    </div>
                    <div class='col-12 col-md-6'>
                      <b>${{ getSubscriptionAmount() }}</b>
                    </div>
                  </div>
                  <div class='row mt-3'>
                    <div class='col col-12 col-md-6'>
                      <mat-label>Interval</mat-label>
                    </div>
                    <div class='col-12 col-md-6'>
                      <b>{{ subscription.payment_interval }}</b>
                    </div>
                  </div>
                  <div class='row mt-3'>
                    <div class='col col-12 col-md-6'>
                      <mat-label>Period</mat-label>
                    </div>
                    <div class='col-12 col-md-6'>
                      <b>{{ subscription.payment_period }}</b>
                    </div>
                  </div>
                </ng-template>
                <ng-container *ngIf='subscription.billed_subordinates != null'>
                  <div class='row mt-3'>
                    <div class='col col-12 col-md-6'>
                      <mat-label>Billed subordinates</mat-label>
                    </div>
                    <div class='col-12 col-md-6'>
                      <b>{{ subscription.billed_subordinates }}</b>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf='subscription.cost_subordinates != null'>
                  <div class='row mt-3'>
                    <div class='col col-12 col-md-6'>
                      <mat-label>Cost of subordinates</mat-label>
                    </div>
                    <div class='col-12 col-md-6'>
                      <b>${{ subscription.cost_subordinates }}</b>
                    </div>
                  </div>
                  <div class='row mt-3'>
                    <div class='col col-12 col-md-6'>
                      <mat-label>Total cost</mat-label>
                    </div>
                    <div class='col-12 col-md-6'>
                      <b>${{ getTotalCost() }}</b>
                    </div>
                  </div>
                </ng-container>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6 align-content-center'>
          <mat-label>Customer</mat-label>
        </div>
        <div class='col col-12 col-md-6 ali'>
          <app-text-field [canCopy]='true' formControlName='customer_id' label='Customer'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6 align-content-center'>
          <mat-label>Subscription ID</mat-label>
        </div>
        <div class='col col-12 col-md-6'>
          <app-text-field [canCopy]='true' [disabled]='true' [value]='subscription.subscription_id'
                          label='Subscription ID'></app-text-field>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6 align-content-center'>
          <mat-label>Team Code</mat-label>
        </div>
        <div class='col col-12 col-md-6'>
          <app-text-field [canCopy]='true' [disabled]='isLegacyStripe' formControlName='discount'
                          label='Select discount'></app-text-field>
        </div>
      </div>
      <div *ngIf='subscription.team_code && !isLegacyStripe' class='row mt-3'>
        <div class='col col-12 col-md-6 offset-0 offset-md-6 align-content-center'>
          Remove Discount:
          <mat-slide-toggle formControlName='discard_discount'></mat-slide-toggle>
        </div>
      </div>
      <div class='row mt-3'>
        <div class='col col-12 col-md-6'>
          Payed by manager<br />
          <span class='text-muted'>Functionality paid by manager becomes active if user is assigned to a manager</span>
        </div>
        <div class='col col-12 col-md-6'>
          <mat-slide-toggle [disabled]='!account.manager_id'
                            formControlName='manager_pay'></mat-slide-toggle>
        </div>
      </div>
      <div *ngIf='showSelfBillWarning' class='row mt-2'>
        <div class='col col-12'>
          <div class='alert alert-warning mb-0'>
            User should create a valid subscription to be able to work.
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #noSubsciprtion>
    <div class='alert alert-danger'>
      <p>Account <b>{{ account.email }}</b> has not subscription!</p>
      <p>You can change the customer ID only</p>
      <p>Email address in Retreva app should match email address in Stripe of the selected customer ID</p>
      <div [formGroup]='inputForm' class='ManageSubscriptionDialog__form'>
        <div class='row mt-3'>
          <div class='col col-12 col-md-6 align-content-center'>
            <mat-label>Customer</mat-label>
          </div>
          <div class='col col-12 col-md-6 ali'>
            <app-text-field [canCopy]='true' formControlName='customer_id' label='Customer'></app-text-field>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>